import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import { RcFile } from 'antd/lib/upload';
import axios, { CancelTokenSource } from 'axios';
import { useRef, useState } from 'react';
import uploadFileService from 'services/uploadService';
import {
  GALLERY_IMAGE_ACCEPT,
  UPLOAD_FILE_ADDRESS_PREFIX,
} from 'utils/constants';

type Props = {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
};

export const RevxInputImage = ({
  value,
  onChange,
  disabled = false,
}: Props) => {
  const [curValue, setCurValue] = useState(value || '');
  const [loading, setLoading] = useState(false);
  const cancelSources = useRef<CancelTokenSource[]>([]);
  const beforeUpload = async (file: RcFile) => {
    const source = axios.CancelToken.source();
    cancelSources.current.push(source);
    setLoading(true);
    const ret = await uploadFileService.uploadFile({
      file,
      cancelTokenObject: {
        token: source.token,
      },
    });
    if (ret) {
      const imagePath = new URL(ret.path).pathname.replace(/^\//, '');
      setCurValue(imagePath);
      if (onChange) onChange(imagePath);
    }
    setLoading(false);

    return Promise.reject();
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );
  return (
    <Upload
      listType="picture-card"
      showUploadList={false}
      accept={GALLERY_IMAGE_ACCEPT}
      beforeUpload={beforeUpload}
      disabled={disabled}
    >
      {curValue ? (
        <img
          src={UPLOAD_FILE_ADDRESS_PREFIX + curValue}
          alt="uploaded"
          style={{ width: '100%' }}
        />
      ) : (
        uploadButton
      )}
    </Upload>
  );
};
